export const isAuthPageUtil = (pathname: string) => pathname.split('/')?.at(2) === 'auth';

export const isUnsubscribePageUtil = (pathname: string) =>
  pathname.split('/')?.at(2) === 'unsubscribe';

export const isHubspotCallbackUtil = (pathname: string) =>
  pathname.indexOf('/external/hubspot/callback') !== -1;

export const isUnprotectedRoutesMiddlewareUtil = (pathname: string) => {
  const unprotectedRoutes = new Set(['auth', 'unsubscribe', 'external']);
  const segments = pathname.split('/').filter(Boolean);

  return [segments[0], segments[1]].some((segment) => segment && unprotectedRoutes.has(segment));
};
